// extracted by mini-css-extract-plugin
module.exports = {"column":"oTLfI","divider":"_2PX0C"};